import styled from "styled-components";

export const Titulo = styled.div`
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 8px;
`;

export const Alerta = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  background-color: #fff3cd;
  color: #8a6d3b;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.4;
  margin-bottom: 12px;

  svg {
    flex-shrink: 0;
    margin-top: 2px;
  }
`;

export const Placa = styled.div`
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 6px;
`;

export const Tabela = styled.div`
  border: 1px solid #f0a35e;
  border-radius: 8px;
  overflow: hidden;
`;

export const Linha = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 8px 12px;
  font-size: 13px;
`;

export const Header = styled(Linha)`
  color: #888;
  font-size: 12px;
`;

export const LinhaItem = styled(Linha)`
  color: #333;

  &:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.neutral.neutral05};
  }
`;
